/** Shared template category values (matches invitation_templates.category). */
export const INVITATION_BUILDER_CATEGORIES = [
  { label: "All", value: "all" },
  { label: "Wedding", value: "wedding" },
  { label: "Birthday", value: "birthday" },
  { label: "Graduation", value: "graduation" },
];
